import React, { useState, useEffect } from "react";
import "./InputSearchs.css";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';
import baseURL from '../url';

export default function InputSearchs() {
    const LIMITE_INICIAL = 10;

    const [searchTerm, setSearchTerm] = useState("");
    const [filteredProducto, setFilteredProducto] = useState([]);
    const [filteredTiendas, setFilteredTiendas] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const [noResults, setNoResults] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [tiendas, setTiendas] = useState([]);
    const [productos, setProductos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [categoriasProductos, setCategoriasProductos] = useState([]);
    const [limiteProductos, setLimiteProductos] = useState(LIMITE_INICIAL);

    useEffect(() => {
        cargarProductos();
        cargarCategoriaProductos();
        cargarCategoriaTienda();
    }, []);

    const cargarProductos = () => {
        fetch(`${baseURL}/tiendasFrontend.php`)
            .then(res => res.json())
            .then(data => {
                setTiendas(data.tiendas || []);
                setProductos(data.tiendas.flatMap(t => t?.productos || []));
            })
            .catch(err => console.error(err));
    };

    const cargarCategoriaTienda = () => {
        fetch(`${baseURL}/categoriaTiendaGet.php`)
            .then(res => res.json())
            .then(data => setCategorias(data.categorias || []));
    };

    const cargarCategoriaProductos = () => {
        fetch(`${baseURL}/categoriasGet.php`)
            .then(res => res.json())
            .then(data => setCategoriasProductos(data?.categorias || []));
    };

    const handleSearch = (event) => {
        const value = event.target.value;
        setSearchTerm(value);
        setLimiteProductos(LIMITE_INICIAL); // 🔥 reset al buscar

        const filteredProductos = productos?.filter(producto => {
            const matchesTitle = producto.titulo?.toLowerCase().includes(value.toLowerCase());
            const matchesCategory = categoriasProductos?.some(categoria =>
                categoria?.idCategoria === producto?.idCategoria &&
                categoria?.categoria?.toLowerCase()?.includes(value.toLowerCase())
            );
            return matchesTitle || matchesCategory;
        });

        const filteredTiendas = tiendas?.filter(tienda => {
            const matchesName = tienda.nombre?.toLowerCase().includes(value.toLowerCase());
            const matchesCategory = categorias?.some(categoria =>
                categoria?.idCategoria === tienda?.idCategoria &&
                categoria?.categoria.toLowerCase().includes(value.toLowerCase())
            );
            return matchesName || matchesCategory;
        });

        setFilteredProducto(filteredProductos);
        setFilteredTiendas(filteredTiendas);
        setShowResults(value !== "");
        setNoResults(value !== "" && filteredProductos.length === 0 && filteredTiendas.length === 0);
    };

    const productosVisibles = filteredProducto?.slice(0, limiteProductos);

    return (
        <div className="fondo-input">
            <div className="search-container">
                <div className="inputSerch" onClick={() => setModalIsOpen(true)}>
                    <FontAwesomeIcon icon={faSearch} className="search-icon" />
                    <strong>Buscar</strong>
                </div>

                <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={() => setModalIsOpen(false)}
                    className="modalInput"
                    overlayClassName="overlayInput"
                >
                    <fieldset className="inputSearch">
                        <FontAwesomeIcon icon={faSearch} className="search-icon" />
                        <input
                            type="text"
                            placeholder="Buscar..."
                            value={searchTerm}
                            onChange={handleSearch}
                            className="input"
                        />
                    </fieldset>

                    {showResults && (
                        <div className="modalSearch">

                            {/* ===== TIENDAS ===== */}
                            {filteredTiendas.length > 0 && (
                                <div className="sectionSearch">
                                    <h3>Tiendas</h3>
                                    <hr />
                                    {filteredTiendas.map(tienda => (
                                        <div key={tienda.idTienda}>
                                            <a href={`/tienda/${tienda.idTienda}/${tienda.nombre.replace(/\s+/g, '-')}`}>
                                                <img src={tienda.imagen1} alt="" />
                                                <div>
                                                    <h4>{tienda.nombre}</h4>
                                                    {categorias
                                                        .filter(c => c.idCategoria === tienda.idCategoria)
                                                        .map(c => (
                                                            <h6 key={c.idCategoria}>{c.categoria}</h6>
                                                        ))}
                                                </div>
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* ===== PRODUCTOS ===== */}
                            {productosVisibles?.length > 0 && (
                                <div className="sectionSearch">
                                    <h3>Productos</h3>
                                    <hr />

                                    {productosVisibles?.map(item => (
                                        <div key={item?.idProducto}>
                                            <Link to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`}>
                                                <img src={item?.imagen1} alt="" />
                                                <div>
                                                    <h4>{item?.titulo}</h4>
                                                    {categoriasProductos
                                                        .filter(c => c?.idCategoria === item?.idCategoria)
                                                        .map(c => (
                                                            <h6 key={c?.idCategoria}>{c?.categoria}</h6>
                                                        ))}
                                                </div>
                                            </Link>
                                        </div>
                                    ))}

                                    {productosVisibles?.length < filteredProducto?.length && (
                                        <button
                                            className="mostrar-mas-btn"
                                            onClick={() => setLimiteProductos(prev => prev + 10)}
                                        >
                                            Ver más 
                                        </button>
                                    )}
                                </div>
                            )}

                            {noResults && <p>No se encontraron resultados.</p>}
                        </div>
                    )}
                </Modal>
            </div>
        </div>
    );
}
